import * as fromRoot from '../../state/app.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserGroupActions, UserGroupActitonTypes } from './userGroup.actions';
import { UserGroup } from '../../_models/user_group';
import { UserZone} from '../../_models/user_zone';
import { Zone } from '../../_models/zone';

import { DbTransform } from '../../_helpers/db.transform';


export interface State extends fromRoot.State {
	userGroups: UserGroupState;
}

export interface UserGroupState {
  currentUserGroup: UserGroup;
	userGroupList: UserGroup[];
	userZoneList: UserZone[];
	zoneList: Zone[];
	filterFields: any;
	error: string;
}

const dbt: DbTransform = new DbTransform(localStorage.getItem('enviroment'));

const initialItem: UserGroup = {
  id: null,
  name: '',
	description: '',
	activated: false
};

const initialState: UserGroupState = {
  currentUserGroup: initialItem,
	userGroupList: [],
	userZoneList: [],
	zoneList: [],
	filterFields: [],
	error: ''
};

const getUserGroupFeatureState = createFeatureSelector<UserGroupState>('userGroups');

export const getCurrentUserGroup = createSelector(
    getUserGroupFeatureState,
    state => state.currentUserGroup
);

export const getUserGroupList = createSelector(
	getUserGroupFeatureState,
	state => state.userGroupList
);

export const getFilterFields = createSelector(
	getUserGroupFeatureState,
	state => state.filterFields
);

export const getError = createSelector(
	getUserGroupFeatureState,
	state => state.error
);

export const getUserZoneList = createSelector(
	getUserGroupFeatureState,
	state => state.userZoneList
);

export const getZoneList = createSelector(
	getUserGroupFeatureState,
	state => state.zoneList
);

// Primer parámetro es el "estado ngrx" almacenado en ese momento.
// Segundo parámetro es la acción que se va a procesar.
export function reducer(state = initialState, action: UserGroupActions): UserGroupState {

	// console.log('--> UserGroup Reduce --> Estado actual: ' + JSON.stringify(state));
	// console.log('--> Action UserGroup type: ');
	// console.log(action.type);

	switch (action.type) {

		case UserGroupActitonTypes.SetCurrentUserGroup:

			console.log('--> Entando en acción SetCurrentUserGroup.');

			if (action.payload !== null) {

				return {
					...state,
					currentUserGroup: action.payload
				};
			} else {
				return {
					...state,
					currentUserGroup: initialItem
				};
			}

		case UserGroupActitonTypes.SetFilterFields:

			console.log('--> Entando en acción SetFilterFields.');

			return {
                ...state,
                filterFields: action.payload
			};

		case UserGroupActitonTypes.ClearUserGroup:

			console.log('--> Entando en acción ClearUserGroup.');

			return {
					...state,
					currentUserGroup: null
				};

		case UserGroupActitonTypes.InicializeUserGroup:

			console.log('--> Entando en acción InicializeUserGroup.');

			state = initialState;

			return state;


		case UserGroupActitonTypes.LoadUserGroupsSuccess:

			console.log('--> Entando en acción LoadUserGroupsSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					userGroupList: action.payload,
					error: ''
				};

		case UserGroupActitonTypes.LoadUserGroupsFail:

			console.log('--> Entando en acción LoadUserGroupsFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					userGroupList: [],
					error: action.payload
				};

		case UserGroupActitonTypes.UpdateUserGroupSuccess:

			console.log('--> Entando en acción UpdateUserGroupSuccess.');

			// Se actualiza en los proyectos actuales el proyecto que se ha modificado y el resto se deja como estaba.

			let auxUserGroupList = [];

			if (action.payload !== undefined) {
				console.log(' -> El userGroup a modificar es:');
				console.log(action.payload);

				if (action.payload != null) {
					auxUserGroupList = state.userGroupList.map(
					item => action.payload[dbt.t('id')] === item[dbt.t('id')] ? action.payload : item);

					return {
						...state,
						userGroupList: auxUserGroupList,
						currentUserGroup: action.payload,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El userGroup a modificar está vacío.');

				return {
					...state,
					error: 'No se ha podido modificar el userGroupe.'
				};
			}

		case UserGroupActitonTypes.UpdateUserGroupFail:

			console.log('--> Entrando en acción UpdateUserGroupFail.');

			return {
					...state,
					error: action.payload
				};

		case UserGroupActitonTypes.CreateUserGroupSuccess:

			console.log('--> Entrando en acción CreateUserGroupSuccess.');

			if (action.payload !== undefined) {
				console.log(' -> El userGroup creado es:');
				console.log(action.payload);

				if (action.payload != null) {

					state.userGroupList.push(action.payload);

					return {
						...state,
						userGroupList: state.userGroupList,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El elemento a crear está vacío.');

				return {
					...state,
					currentUserGroup: null,
					error: 'No se ha podido crear el userGroupe.'
				};
			}

		case UserGroupActitonTypes.CreateUserGroupFail:

			console.log('--> Entrando en acción CreateUserGroupFail.');

			return {
					...state,
					currentUserGroup: null,
					error: action.payload
				};

		case UserGroupActitonTypes.DeleteUserGroupSuccess:

			console.log('--> Entrando en acción DeleteUserGroupSuccess.');

			if (action.payload !== undefined) {
				console.log(' -> UserGroup borrado con éxito es:');
				console.log(action.payload);

				if (action.payload != null) {

					const filterList = state.userGroupList.filter((item) => item[dbt.t('id')].toString() !== action.payload.toString());

					console.log(' -> Lista filtrada de userGroupes:');
					console.log(filterList);

					return {
						...state,
						userGroupList: filterList,
						currentUserGroup: null,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El userGroup a borrar está vacío.');

				return {
					...state,
					currentUserGroup: null,
					error: 'No se ha podido borrar el userGroupe.'
				};
			}

		case UserGroupActitonTypes.DeleteUserGroupFail:

			console.log('--> Entrando en acción DeleteUserGroupSuccess.');

			return {
					...state,
					currentUserGroup: null,
					error: action.payload
				};

		// -------------------------------------
		//				Acciones para UserZone
		// -------------------------------------

		case UserGroupActitonTypes.LoadUserZonesSuccess:

			console.log('--> Entando en acción LoadUserZonesSuccess. => Payload = ');
			//console.log(action.payload);

			return {
					...state,
					userZoneList: action.payload,
					error: ''
				};

		case UserGroupActitonTypes.LoadUserZonesFail:

			console.log('--> Entando en acción LoadUserZonesFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					userZoneList: [],
					error: action.payload
				};

		case UserGroupActitonTypes.LoadZonesSuccess:

			console.log('--> Entando en acción LoadZonesSuccess. => Payload = ');
			//console.log(action.payload);

			return {
					...state,
					zoneList: action.payload,
					error: ''
				};

		case UserGroupActitonTypes.LoadZonesFail:

			console.log('--> Entando en acción LoadZonesFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					zoneList: [],
					error: action.payload
				};

		case UserGroupActitonTypes.CreateUserZoneSuccess:

			console.log('--> Entrando en acción CreateUserZoneSuccess.');

			if (action.payload !== undefined) {
				console.log(' -> El UserZone creado es:');
				console.log(action.payload);

				if (action.payload != null) {

					state.userZoneList.push(action.payload);

					return {
						...state,
						userZoneList: state.userZoneList,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El elemento a crear está vacío.');

				return {
					...state,
					error: 'No se ha podido crear el UserZone.'
				};
			}

		case UserGroupActitonTypes.CreateUserZoneFail:

			console.log('--> Entrando en acción CreateUserZoneFail.');

			return {
					...state,
					error: action.payload
				};

		case UserGroupActitonTypes.DeleteUserZoneSuccess:

			console.log('--> Entrando en acción DeleteUserZoneSuccess.');

			if (action.payload !== undefined) {
				console.log(' -> UserZone borrado con éxito es:');
				console.log(action.payload);

				if (action.payload != null) {

					const filterList = state.userZoneList.filter((item) => item[dbt.t('id')].toString() !== action.payload.toString());

					console.log(' -> Lista filtrada de userZone:');
					console.log(filterList);

					return {
						...state,
						userZoneList: filterList,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El userZone a borrar está vacío.');

				return {
					...state,
					error: 'No se ha podido borrar el userZone.'
				};
			}

		case UserGroupActitonTypes.DeleteUserZoneFail:

			console.log('--> Entrando en acción DeleteUserZoneSuccess.');

			return {
					...state,
					error: action.payload
				};
		// ---------------------- Acción final por defecto
		default:
			return state;
	}
}
